import { render } from "./user-panel.vue?vue&type=template&id=3f978292"
import script from "./user-panel.vue?vue&type=script&lang=js"
export * from "./user-panel.vue?vue&type=script&lang=js"

import "./user-panel.vue?vue&type=style&index=0&id=3f978292&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/user-panel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3f978292"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3f978292', __exports__)) {
    api.reload('3f978292', __exports__)
  }
  
  module.hot.accept("./user-panel.vue?vue&type=template&id=3f978292", () => {
    api.rerender('3f978292', render)
  })

}


export default __exports__